import { render, staticRenderFns } from "./batchUpdate.vue?vue&type=template&id=392c3a9a&"
import script from "./batchUpdate.vue?vue&type=script&lang=js&"
export * from "./batchUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports